import { Box, IconButton, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { AddImageToInputIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/AddImageToInputIcon";
import CloseIcon from "@mui/icons-material/Close";
import { useAppDispatch } from "../../../../store/hooks";

interface InputImageProps {
  inputValue: File | string | null;
  isGenerateImgLoading: boolean | undefined;
  handleInputImageChange: ((image: File | null) => void) | undefined;
  appTitle: string;
  appDesc?: string;
  handleClearInput: (() => void) | undefined;
  videoSource?: boolean;
}

export const UploadImageModal = ({
  inputValue,
  isGenerateImgLoading,
  handleInputImageChange,
  appTitle,
  handleClearInput,
  videoSource,
  appDesc,
}: InputImageProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const openFileInput = () => {
    fileInputRef?.current?.click();
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && handleInputImageChange) {
      handleInputImageChange(file);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file && handleInputImageChange) {
      handleInputImageChange(file);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const removeImage = () => {
    handleClearInput?.();
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input value
    }
  };

  return (
    <Box
      className={`input-container ${videoSource && "video-input-container"}`}
    >
      <input
        type="file"
        id="image-input"
        ref={fileInputRef}
        accept="image/jpeg, image/png"
        style={{ display: "none" }}
        onChange={handleImageUpload}
      />

      <Box className="uploaded-img-container">
        <Box
          className="input-description-container"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "0",
            mb: "8px",
          }}
        >
          <Typography className="image-input-text">{appTitle}</Typography>
          {appDesc && (
            <Typography className="image-input-desc">{appDesc}</Typography>
          )}
        </Box>

        {!inputValue ? (
          <Box className="image-input">
            <Box onDragOver={handleDragOver} onDrop={handleDrop}>
              <Box
                onClick={openFileInput}
                sx={{
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <AddImageToInputIcon />
                <Typography className="input-drop-title">
                  Upload image
                </Typography>
                <Typography className="input-accept-note">
                  Format: jpg & Max file size: 5 MB
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box
            className="image-preview one-image"
            sx={{
              position: "relative",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            <img
              src={
                typeof inputValue === "string"
                  ? inputValue
                  : inputValue
                  ? URL.createObjectURL(inputValue)
                  : undefined
              }
              className="img-preview"
              alt="Uploaded preview"
            />
            {!isGenerateImgLoading && (
              <IconButton
                className="delete-btn"
                onClick={removeImage}
                sx={{
                  position: "absolute",
                  top: "-15px",
                  right: "-15px",
                  backgroundColor: "rgba(62, 84, 96, 0.5)",
                  opacity: 1,
                  zIndex: 100,
                  transition: "opacity 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#3E5460",
                  },
                }}
              >
                <CloseIcon
                  sx={{
                    color: "var(--Main_icons_color)",
                    fontSize: "1rem",
                  }}
                />
              </IconButton>
            )}
          </Box>
        )}
        {inputValue && !isGenerateImgLoading ? (
          <Typography className="upload-another-img" onClick={openFileInput}>
            Upload another photo
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};
